import types from '../types/types';

const initialState = {
  selectedOfficeId: null,
};
const officeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.selectOffice:
      return {
        ...state,
        selectedOfficeId: action.payload,
      };

    default:
      return state;
  }
};
export default officeReducer;
